export const normalizeCompanySlugCandidate = (rawSlug: string): string => rawSlug.trim().toLowerCase();

const resolvePortalPathTenantId = (rawSlug: string, companySlugTenantId: string | null): string =>
	companySlugTenantId ?? rawSlug.trim().toUpperCase();

export default resolvePortalPathTenantId;
